import {
  CABIN_INTRO_STEP,
  CABIN_PRICE_STEP,
} from "Components/Features/CheckPrice/Products/RiskProducts/HouseProducts/Cabin/cabinSteps";
import {
  CABIN_CONTENTS_ABOUT_STEP,
  CABIN_CONTENTS_INTRO_STEP,
  CABIN_CONTENTS_PRICE_STEP,
} from "Components/Features/CheckPrice/Products/RiskProducts/HouseProducts/CabinContents";

import { CABIN_ABOUT_STEP } from "Components/Features/CheckPrice/Products/RiskProducts/HouseProducts/Cabin";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { mapFormToInjuries } from "Store/priceCalculation/productMappers/common/injuriesMapper";
import { nullableFormBooleanToNullableBoolean } from "Utils/formUtils";
import { isDefined } from "Utils/functions";

export type CabinContentsProductBackend = {
  name: INSURANCE_NAME_VALUE;
  coverageGroup: any;
  address: {
    zipCode: string;
    city: string;
  };
  coverageAmountCabinContent: number;
  hasElectricity: boolean;
  hasRental?: boolean;
  hasTapWater: boolean;
  damageCountRecentYears: number;
  yearOfLastDamage?: number;
};

export function mapToCommerceCabinContents(data: {
  [key: string]: any;
}): CabinContentsProductBackend {
  const introCabinContents =
    data.formData[CABIN_CONTENTS_INTRO_STEP.id] ??
    data.formData[CABIN_INTRO_STEP.id];
  const aboutCabinContents =
    data.formData[CABIN_CONTENTS_ABOUT_STEP.id] ??
    data.formData[CABIN_ABOUT_STEP.id];
  const checkPrice =
    data.formData[CABIN_CONTENTS_PRICE_STEP.id] ??
    data.formData[CABIN_PRICE_STEP.id];

  const postNumber = aboutCabinContents.postNumber
    ? aboutCabinContents.postNumber.toString()
    : introCabinContents.postNumber.toString();

  const coverageAmount = isDefined(checkPrice.contentsInsuranceSum)
    ? checkPrice.contentsInsuranceSum
    : aboutCabinContents.contentsInsuranceSum;

  return {
    name: INSURANCE_NAME_VALUE.CABIN_CONTENTS,
    coverageGroup: data.coverage,
    address: {
      zipCode: postNumber,
      city: aboutCabinContents.city ?? introCabinContents.city,
    },
    coverageAmountCabinContent: coverageAmount,
    hasElectricity: aboutCabinContents.hasElectricity,
    hasRental: nullableFormBooleanToNullableBoolean(
      aboutCabinContents.hasRental,
    ),
    hasTapWater: aboutCabinContents.hasTapWater,
    ...mapFormToInjuries(
      aboutCabinContents.injuries,
      aboutCabinContents.injuryYear,
    ),
  };
}
